
import React, { Component } from 'react';
import { Modal, Form, Input, TreeSelect,Col,Divider,Row } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import validator from '../../../util/validator';
import orgUtil from '../../ui/orgUtil';
import Image from '../../ui/Image';
import Scanner from '../../ui/Scanner';

const fields = [{
    "text": "所属市场",
    "field": "orgCode",
    org: true,
    rules: [
        { required: true, message: '所属市场不能为空!' },
    ]
}, {
    "text": "会员名称",
    "field": "name",
    rules: [
        { required: true, message: '会员名称不能为空!' },
        { max: 32, message: '会员名不能超过32个字符！' },
    ]
}, {
    "text": "竞价会员编号",
    "field": "abbreviation",
    rules: [
        { max: 32, message: '竞价会员编号不能超过32个字符！' },
    ]
}, {
    "text": "证件号码",
    "field": "creditNo",
    rules: [
        { max: 32, message: '证件号码不能超过32个字符！' },
        validator.creditNo
    ]
}, {
    "text": "地址",
    "field": "address",
    rules: [
        { max: 64, message: '地址不能超过64个字符！' },
    ]
}, {
    "text": "联系人",
    "field": "contactMan",
    rules: [
        { max: 16, message: '联系人不能超过16个字符！' },
    ]
}, {
    "text": "联系人证件号",
    "field": "contactManCreditNo",
    rules: [
        validator.creditNo
    ]
}, {
    "text": "联系电话",
    "field": "contactNumber",
    rules: [
        validator.tel
    ]
}, {
    "text": "商户描述",
    "field": "mallDesc",
    "textarea": true,
    rules: [
        { max: 128, message: '联系人不能超过128个字符！' },
    ]
}];

const publicizeImage = [{
    text: '店招图',
    field: 'shopPhoto'
},{
    text: '定位图',
    field: 'locationMap'
}, {
    text: '抖音号',
    field: 'tiktokQr'
}, {
    text: '视频号',
    field: 'videoQr'
}
]


class AgentEditForm extends Component {

    state = {
        orgList: [],
        firstOrg: '',
        //上传特定相关照片
        fileList: {},
        imageUrl: {},
        visible: false
    }

    componentDidMount() {
        orgUtil.findOrg(
            { orgType: 4 },   //只查询市场会员的组织信息
            (res) => {
                let firstOrg = '';
                if (res != null && res.length > 0) {
                    firstOrg = res[0].code;
                }
                this.setState({ orgList: res, firstOrg: firstOrg });
            }
        );
        if (this.props.initFunc) {
            this.props.initFunc(this.initEdit);
        }
    }

    initEdit = (editData) => {
        let image = editData.image;
        let fileList = {};
        let imageUrl = {};
        if (image != null) {
            for (var field in image) {
                if (image[field] != null && image[field] !== "") {
                    fileList[field] = "data:image/jpeg;base64," + image[field].replace(/\r\n/g, "");
                }
            }
            imageUrl = editData.imageUrl;
        }
        this.setState({ fileList: fileList, imageUrl: imageUrl });
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let memberCode = this.props.editData.code
            if (memberCode !== undefined && memberCode != null) {
                values["code"] = memberCode;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            values["mall"] = 1;
            //处理图片
            let imageUrl = this.state.imageUrl;
            let fileList = this.state.fileList;
            let image = {};
            for (let key in fileList) {
                if (imageUrl[key] == null || imageUrl[key] === "") {
                    image[key] = fileList[key];
                } else {
                    image[key] = imageUrl[key];
                }
            }
            values["image"] = image;
            this.transferData(values, "image");
            http.post({
                url: '/mallMember/saveMallMember',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    transferData = (res, field) => {
        let value = res[field];
        for (let key in value) {
            res[field + "." + key] = value[key];
        }
        delete res[field];
    }

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let orgCode = editData.orgCode;
        if (orgCode == null || orgCode === '') {
            orgCode = this.state.firstOrg;
        }
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: item.field === "orgCode" ? orgCode : editData[item.field],
                        })(
                            item.org ? <TreeSelect treeData={this.state.orgList} treeDefaultExpandAll={true} />
                            : item.textarea ? <Input.TextArea disabled={item.disabled} />
                            : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    handleUploadImage = (field, { base64 }) => {
        const list = this.state.fileList;
        const imageUrl = this.state.imageUrl;
        if (field === "vehicleOCR") {
            list["vehicleLicense"] = base64;
            delete imageUrl["vehicleLicense"];
        } else if (field === "buyerOCR") {
            list["buyerCreditFront"] = base64;
            delete imageUrl["buyerCreditFront"];
        } else if (field === "sellerOCR") {
            list["sellerCreditFront"] = base64;
            delete imageUrl["sellerCreditFront"];
        } else {
            list[field] = base64;
            delete imageUrl[field];
        }
        this.setState({ "fileList": list, "imageUrl": imageUrl });
        
    }
    handleRemoveImage = (field, index) => {
        const list = this.state.fileList;
        const imageUrl = this.state.imageUrl;
        delete list[field];
        delete imageUrl[field];
        this.setState({ "fileList": list, "imageUrl": imageUrl });
    }

    createImageDom = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let field = item.field;
            let file = this.state.fileList[field];
            dom.push(
                <Col span={6} key={field} style={{ height: '112px' }}>
                    <Image
                        openScanner={this.showModal.bind(this, field)}
                        onChange={this.handleUploadImage.bind(this, field)}
                        onRemove={this.handleRemoveImage.bind(this, field)}
                        file={file}
                        text={item.text}
                        url={this.state.imageUrl[item.field]}
                    />
                </Col>
            );
        }
        return dom;
    };

    showModal = (field) => {
        this.setState({ visible: true, imageField: field });
        this.state.initScanner();
    };
    hiddenModal = () => {
        this.setState({ visible: false });
    };
    handleScan = (base64) => {
        if (base64 != null && base64 !== "") {
            base64 = "data:image/jpeg;base64," + base64.replace(/\r\n/g, "");
            if (this.state.imageField === "otherImage") {
                const list = this.state.otherImage;
                list.push(base64);
                this.setState({ "otherImage": list });
            } else {
                this.handleUploadImage(this.state.imageField, { base64 });
            }
        }
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="商户信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                    <Divider orientation="left">商户照片</Divider>
                    <Row>
                        {this.createImageDom(publicizeImage)}
                    </Row>
                </Form>
                <Scanner
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    initScanner={(func) => { this.setState({ initScanner: func }) }}
                    onScan={this.handleScan}
                />
            </Modal>
        );
    }
}

const AgentEdit = Form.create()(AgentEditForm);

export default AgentEdit;